{
  "REGISTER": {
    "TRY_WOOT": "계정 만들기",
    "GET_STARTED": "Chatwoot 시작하기",
    "TITLE": "회원가입",
    "TESTIMONIAL_HEADER": "앞으로 나아가기 위한 단 한 걸음",
    "TESTIMONIAL_CONTENT": "고객과 소통하고, 유지하고, 새로운 고객을 찾는 것은 한 걸음이면 됩니다.",
    "TERMS_ACCEPT": "계정을 생성하면 <a href=\"https://www.chatwoot.com/terms\">이용약관</a> 및 <a href=\"https://www.chatwoot.com/privacy-policy\">개인정보 처리방침</a>에 동의하는 것입니다",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Google로 가입"
    },
    "COMPANY_NAME": {
      "LABEL": "회사 이름",
      "PLACEHOLDER": "회사 이름을 입력하십시오. 예: Wayne Enterprises",
      "ERROR": "회사 이름이 너무 짧습니다."
    },
    "FULL_NAME": {
      "LABEL": "전체 이름",
      "PLACEHOLDER": "전체 이름을 입력하십시오. 예: Taeyeon Kim",
      "ERROR": "전체 이름이 너무 짧습니다."
    },
    "EMAIL": {
      "LABEL": "회사 이메일",
      "PLACEHOLDER": "회사 이메일 주소를 입력하십시오. 예: bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "유효한 회사 이메일 주소를 입력하십시오."
    },
    "PASSWORD": {
      "LABEL": "비밀번호",
      "PLACEHOLDER": "비밀번호",
      "ERROR": "비밀번호가 너무 짧습니다.",
      "IS_INVALID_PASSWORD": "비밀번호에는 최소 대문자 1개, 소문자 1개, 숫자 1개, 특수문자 1개가 포함되어야 합니다.",
      "REQUIREMENTS_LENGTH": "최소 6자 이상",
      "REQUIREMENTS_UPPERCASE": "최소 대문자 1개",
      "REQUIREMENTS_LOWERCASE": "최소 소문자 1개",
      "REQUIREMENTS_NUMBER": "최소 숫자 1개",
      "REQUIREMENTS_SPECIAL": "최소 특수문자 1개"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "비밀번호 확인",
      "PLACEHOLDER": "비밀번호 확인",
      "ERROR": "비밀번호가 일치하지 않습니다."
    },
    "API": {
      "SUCCESS_MESSAGE": "회원가입이 완료되었습니다",
      "ERROR_MESSAGE": "Chatwoot 서버에 연결할 수 없습니다. 나중에 다시 시도하십시오."
    },
    "SUBMIT": "계정 만들기",
    "HAVE_AN_ACCOUNT": "이미 계정이 있으십니까?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "인증 이메일 다시 보내기",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
